/**
 * This imports needs to happen with the direct path to prevent importing
 * the whole @tuic/lib it has imports of headers/cookies which can lead to
 * problems in server action environments
 */
import { tryRequest as helperTryRequest } from '@tuic/lib/src/helpers/request';

/**
 * Tries given `request`. If it fails, given `errorMessage` is written to the console before the actual error is written.
 */
export const tryRequest = helperTryRequest;
